<template>
  <b-avatar
    v-if="src.includes('data:')"
    :size="size"
    :src="src"
  />
  <b-avatar
    v-else
    :size="size"
    :src="photo"
    variant="light-primary"
    style="background-color: transparent !important;"
  />

</template>

<script>
import {
  BAvatar,
} from 'bootstrap-vue'

export default {
  name: 'AmAvatarDataUrl',
  components: {
    BAvatar,
  },
  props: {
    src: { type: String, default: '' },
    size: { type: Number | String, default: 60 },
  },
  computed: {
    photo() {
      return `${process.env.VUE_APP_STORAGE_PATH}/${this.src}`
    },
  },
}
</script>

<style scoped>

</style>
